"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.papanicolaouTestMessages = exports.resultMessages = exports.PapanicolaouTest = exports.Result = void 0;
const schema_1 = require("../../../../schema");
var Result;
(function (Result) {
    Result["ABNORMAL"] = "ABNORMAL";
    Result["NORMAL"] = "NORMAL";
})(Result || (exports.Result = Result = {}));
var PapanicolaouTest;
(function (PapanicolaouTest) {
    PapanicolaouTest["MEASURED"] = "MEASURED";
    PapanicolaouTest["NOT_MEASURED"] = "NOT_MEASURED";
})(PapanicolaouTest || (exports.PapanicolaouTest = PapanicolaouTest = {}));
exports.resultMessages = {
    [Result.ABNORMAL]: {
        id: "ktx.transplantationScreening.tumourResearch.gynecology.result.ABNORMAL",
        defaultMessage: "Van eltérés"
    },
    [Result.NORMAL]: {
        id: "ktx.transplantationScreening.tumourResearch.gynecology.result.NORMAL",
        defaultMessage: "Nincs eltérés"
    }
};
exports.papanicolaouTestMessages = {
    [PapanicolaouTest.MEASURED]: {
        id: "ktx.transplantationScreening.tumourResearch.gynecology.papanicolaouTest.MEASURED",
        defaultMessage: "Történt"
    },
    [PapanicolaouTest.NOT_MEASURED]: {
        id: "ktx.transplantationScreening.tumourResearch.gynecology.papanicolaouTest.NOT_MEASURED",
        defaultMessage: "Nem történt"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.ABNORMAL),
    schema_1.Schema.singleChoiceItem(Result.NORMAL)
]);
const papanicolaouTest = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(PapanicolaouTest.MEASURED),
    schema_1.Schema.singleChoiceItem(PapanicolaouTest.NOT_MEASURED)
]);
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .expiration(31536000)
    .default({})
    .sealed(true)
    .properties({ result, papanicolaou_test: papanicolaouTest, comment })
    .interpretation({ vocab: "ktx", code: "gynecology" })
    .tag({ vocab: "snomed", code: "170865004" })
    .tag({ vocab: "ktx", code: "tumour_research" });
